module.exports = __webpack_public_path__ + "img/closeside.3bbe74fb.svg";